import { initExpandsets } from "./lib/expandset.js";
import { initModals } from "./lib/modal.js";
import { initPageHeader } from "./lib/page-header.js";
import { initTabsets } from "./lib/tabset.js";
import "./components/search-box.js";
import "./components/video-hero.js";
import "./components/video-player.js";
import "./components/toggle-class.js";
import "./components/toggle-offscreen.js";
import { initHaloSlider } from "./components/halo-slider";
import "./components/map-embed.js";
import { initProductFeature } from "./components/product-feature.js";
import Glide from "@glidejs/glide";
import "./components/product-filters.js";
import "./components/forms.js";

initExpandsets();
initModals();
initTabsets();
initPageHeader(document.getElementById("page-header"));
initHaloSlider();
initProductFeature();

if (document.querySelector(".product-add-on-glide")) {
    new Glide(".product-add-on-glide", {
        gap: 24,
        perView: 3,
        breakpoints: {
            1300: {
                perView: 2,
            },
            767: {
                perView: 1,
            },
        },
    }).mount();
}

if (document.querySelector(".product-highlights-glide")) {
    new Glide(".product-highlights-glide", {
        type: "carousel",
        gap: 64,
        perView: 1,
        peek: 650,
        breakpoints: {
            2200: {
                peek: 450,
            },
            1700: {
                peek: 300,
            },
            1300: {
                peek: 150,
            },
            767: {
                peek: 20,
            },
        },
    }).mount();
}

if (document.querySelector(".product-software-glide")) {
    new Glide(".product-software-glide", {
        type: "carousel",
        perView: 1,
        animationDuration: 0,
        swipeThreshold: false,
        dragThreshold: false,
        breakpoints: {
            767: {
                animationDuration: 100,
            },
        },
    }).mount();
}
